// components/ConsultationSuccess.jsx
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, Phone, Mail, Home, FileText } from 'lucide-react';

const ConsultationSuccess = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId') || searchParams.get('order'); // ✅
  const refId = searchParams.get('refId') || searchParams.get('ref');       // ✅


  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center p-4" dir="rtl">
      <div className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl overflow-hidden">
        
        {/* Header */}
        <div className="bg-gradient-to-l from-green-500 to-emerald-600 p-8 text-white text-center">
          <CheckCircle2 className="w-20 h-20 mx-auto mb-4" />
          <h1 className="text-3xl font-bold mb-2">پرداخت موفق! 🎉</h1>
          <p className="text-green-100">
            جلسه مشاوره شما با موفقیت رزرو شد
          </p>
        </div>

        {/* Body */}
        <div className="p-8">
          
          {/* کد پیگیری */}
          <div className="bg-slate-50 rounded-xl p-6 mb-6 border-2 border-slate-200">
            <p className="text-sm text-slate-600 mb-2">کد پیگیری تراکنش:</p>
            <p className="text-2xl font-mono font-bold text-slate-800 select-all">
              {refId || 'در حال دریافت...'}
            </p>
            <p className="text-xs text-slate-500 mt-2">
              این کد را برای پیگیری نزد خود نگه دارید
            </p>
          </div>

          {/* شماره سفارش */}
          {orderId && (
            <div className="bg-blue-50 rounded-xl p-4 mb-6 border border-blue-200">
              <p className="text-sm text-blue-700">
                شماره سفارش: <span className="font-bold">#{orderId}</span>
              </p>
            </div>
          )}

          {/* مراحل بعدی */}
          <div className="mb-6">
            <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <FileText className="text-amber-500" size={20} />
              مراحل بعدی:
            </h3>
            
            <div className="space-y-3">
              <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                <div className="w-6 h-6 rounded-full bg-green-500 text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                  1
                </div>
                <p className="text-slate-700 text-sm">
                  تیم ما ظرف <span className="font-bold text-green-600">24 ساعت آینده</span> با شما تماس خواهند گرفت
                </p>
              </div>

              <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                <div className="w-6 h-6 rounded-full bg-blue-500 text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                  2
                </div>
                <p className="text-slate-700 text-sm">
                  زمان دقیق جلسه مشاوره با شما هماهنگ می‌شود
                </p>
              </div>

              <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                <div className="w-6 h-6 rounded-full bg-purple-500 text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                  3
                </div>
                <p className="text-slate-700 text-sm">
                  لینک جلسه آنلاین از طریق پیامک/ایمیل برای شما ارسال می‌شود
                </p>
              </div>
            </div>
          </div>

          {/* اطلاعات تماس */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-6">
            <h4 className="font-bold text-amber-900 mb-3 flex items-center gap-2">
              <Phone size={18} />
              نیاز به پشتیبانی؟
            </h4>
            <div className="space-y-2 text-sm text-amber-800">
              <p className="flex items-center gap-2">
                <Phone size={14} />
                <span>تلفن: 08337223368</span>
              </p>
              <p className="flex items-center gap-2">
                <Mail size={14} />
                <span>ایمیل: info@hooshjadid.ir</span>
              </p>
            </div>
          </div>

          {/* دکمه بازگشت */}
          <Link
            to="/"
            className="w-full bg-gradient-to-l from-slate-600 to-slate-700 text-white font-bold py-4 rounded-xl hover:from-slate-700 hover:to-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
          >
            <Home size={20} />
            بازگشت به صفحه اصلی
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConsultationSuccess;
